import { Calendar, ValidityPeriod } from '@app/pcs/models';
import { Action } from '@ngrx/store';

export enum CalendarEditActionTypes {
  FetchCalendar = '[CalendarEdit] Fetch Calendar',
  FetchCalendarSuccess = '[CalendarEdit] Fetch Calendar Success',
  InitCalendarEditTemplate = '[CalendarEdit] Init Calendar Edit Template',
  SelectDay = '[CalendarEdit] Select Day',
  SelectMonth = '[CalendarEdit] Select Month',
  SelectYear = '[CalendarEdit] Select Year',
  SelectWeekDays = '[CalendarEdit] Select Week Days',
  SelectCalendarRange = '[CalendarEdit] Select Calendar Range',
  UpdateValidityPeriod = '[CalendarEdit] Update Validity Period',
  UpdateValidityPeriodSuccess = '[CalendarEdit] Update Validity Period Success',
  UpdateValidityPeriodFail = '[CalendarEdit] Update Validity Period Fail',
  ResetSelection = '[CalendarEdit] Reset Selection'
}

interface SelectDaysRangePayload {
  start: number;
  end: number;
}

export class FetchCalendar implements Action {
  readonly type = CalendarEditActionTypes.FetchCalendar;
}

export class FetchCalendarSuccess implements Action {
  readonly type = CalendarEditActionTypes.FetchCalendarSuccess;

  constructor(public payload: Calendar) {
  }
}

export class InitCalendarEditTemplate implements Action {
  readonly type = CalendarEditActionTypes.InitCalendarEditTemplate;

  constructor(public payload: Calendar) {
  }
}

export class SelectDay implements Action {
  readonly type = CalendarEditActionTypes.SelectDay;

  constructor(public payload: { dayIndex: number; monthIndex: number }) {
  }
}

export class SelectMonth implements Action {
  readonly type = CalendarEditActionTypes.SelectMonth;

  constructor(public payload: number) {
  }
}

export class SelectYear implements Action {
  readonly type = CalendarEditActionTypes.SelectYear;

  constructor(public payload: number) {
  }
}

export class SelectWeekDays implements Action {
  readonly type = CalendarEditActionTypes.SelectWeekDays;

  constructor(public payload: any) {
  }
}

export class SelectCalendarRange implements Action {
  readonly type = CalendarEditActionTypes.SelectCalendarRange;

  constructor(public payload: SelectDaysRangePayload) {
  }
}

export class ResetSelection implements Action {
  readonly type = CalendarEditActionTypes.ResetSelection;
}

export class UpdateValidityPeriod implements Action {
  readonly type = CalendarEditActionTypes.UpdateValidityPeriod;

  constructor(public payload: {validityPeriod: ValidityPeriod; existingPath: boolean}) {
  }
}

export class UpdateValidityPeriodSuccess implements Action {
  readonly type = CalendarEditActionTypes.UpdateValidityPeriodSuccess;

  constructor(public payload: Calendar) {
  }
}

export class UpdateValidityPeriodFail implements Action {
  readonly type = CalendarEditActionTypes.UpdateValidityPeriodFail;

  constructor(public payload: Error) {
  }
}

export type CalendarEditActions =
  | FetchCalendar
  | FetchCalendarSuccess
  | InitCalendarEditTemplate
  | SelectDay
  | SelectMonth
  | SelectYear
  | SelectWeekDays
  | SelectCalendarRange
  | UpdateValidityPeriod
  | UpdateValidityPeriodSuccess
  | UpdateValidityPeriodFail
  | ResetSelection;
